import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { getPaymentMethodLogoConfig } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentMethodLogoProps as Props } from './types';

export const PaymentMethodLogo = memo(({ className, iconType }: Props) => {
  const { src, label } = getPaymentMethodLogoConfig(iconType);

  return (
    <Styled.Image
      className={classnames('PaymentMethodLogo', className)}
      src={src}
      alt={label}
      sx={SX.root}
    />
  );
});

PaymentMethodLogo.displayName = 'PaymentMethodLogo';
